import { asset } from '../assets';
import { SiteFooter } from '../components/SiteFooter';
import { SiteHeader } from '../components/SiteHeader';
import { ProductGallery } from '../components/ProductGallery';
import { NotesField } from '../components/NotesField';
import { CustomSizeField } from '../components/CustomSizeField';
import { QuoteActions } from '../components/QuoteActions';
import { usePageSetup } from '../hooks/usePageSetup';

const title = "Posters Printing - INGAZ Print";

function PostersProduct() {
  usePageSetup({ title });

  return (
    <>
      <SiteHeader />
        <main>
          {/* Product Details Section */}
          <section className="product-details-section">
            <div className="product-container">
              {/* Left: Product Image Gallery */}
              <ProductGallery alt="Posters Printing" images={[asset('assets/poster_hero_new.png'), asset('assets/poster_angle_new.png'), asset('assets/poster_detail_new.png'), asset('assets/poster_variation_new.png')]} />
              <div className="product-info">
                <h1 className="product-title" data-en="Posters" data-ar="الملصقات">Posters</h1>
                <p className="product-description" data-en="High-quality large format poster printing for marketing, events, and promotional campaigns." data-ar="طباعة ملصقات كبيرة الحجم وعالية الجودة للتسويق والفعاليات والحملات الترويجية.">High-quality large format poster printing for marketing, events, and promotional campaigns.</p>
                <div className="key-features">
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/time.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Durable" data-ar="متين">Durable</div>
                      <div className="feature-detail" data-en="Long lasting" data-ar="يدوم طويلاً">Long lasting</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/star.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Vibrant" data-ar="نابض بالحياة">Vibrant</div>
                      <div className="feature-detail" data-en="High resolution" data-ar="دقة عالية">High resolution</div>
                    </div>
                  </div>
                  <div className="feature-item">
                    <div className="feature-icon-small"><img src={asset('assets/truck.svg')} alt="" /></div>
                    <div>
                      <div className="feature-name" data-en="Fast Delivery" data-ar="تسليم سريع">Fast Delivery</div>
                      <div className="feature-detail" data-en="Quick turnaround" data-ar="إنجاز سريع">Quick turnaround</div>
                    </div>
                  </div>
                </div>
                <div className="product-benefits">
                  <h3 data-en="Why this product works" data-ar="لماذا يعمل هذا المنتج">Why this product works</h3>
                  <ul className="benefits-list">
                    <li data-en="High visibility for your marketing message" data-ar="رؤية عالية لرسالتك التسويقية">High visibility for your marketing message</li>
                    <li data-en="Vibrant full-color large format printing" data-ar="طباعة ملونة كاملة بحجم كبير">Vibrant full-color large format printing</li>
                    <li data-en="Multiple paper sizes and premium finishes" data-ar="أحجام ورق متعددة وتشطيبات فاخرة">Multiple paper sizes and premium finishes</li>
                    <li data-en="Perfect for indoor and outdoor advertising" data-ar="مثالي للإعلانات الداخلية والخارجية">Perfect for indoor and outdoor advertising</li>
                  </ul>
                </div>
                {/* Common Use Cases */}
                <div className="use-cases">
                  <h3 data-en="COMMON USE CASES" data-ar="حالات الاستخدام الشائعة">COMMON USE CASES</h3>
                  <div className="use-cases-grid">
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/launch.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Movie Promotions" data-ar="العروض الترويجية للأفلام">Movie Promotions</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/star.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Retail Advertising" data-ar="إعلانات التجزئة">Retail Advertising</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/calendar.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Event Signage" data-ar="لافتات الأحداث">Event Signage</div>
                    </div>
                    <div className="use-case-item">
                      <div className="use-case-icon"><img src={asset('assets/store.svg')} alt="" /></div>
                      <div className="use-case-name" data-en="Office Decor" data-ar="ديكور المكاتب">Office Decor</div>
                    </div>
                  </div>
                </div>
                <QuoteActions configureOnly productType={title.replace(' - INGAZ Print', '')} />
                <p className="help-text" data-en="Need help? Our design team is ready to assist you." data-ar="تحتاج مساعدة؟ فريق التصميم لدينا جاهز لمساعدتك.">Need help? Our design team is ready to assist you.</p>
              </div>
            </div>
          </section>
          {/* Configuration Section */}
          <section className="configuration-section" id="configuration">
            <div className="config-container">
              <div className="config-main">
                <h2 data-en="Configure Your Posters" data-ar="تكوين الملصقات الخاصة بك">Configure Your Posters</h2>
                {/* Quantity */}
                <div className="config-group">
                  <label htmlFor="quantity" data-en="Quantity" data-ar="الكمية">Quantity</label>
                  <input type="number" id="quantity" placeholder="Enter quantity" min={1} defaultValue={10} data-placeholder-en="Enter quantity" data-placeholder-ar="أدخل الكمية" />
                </div>
                {/* Size */}
                <div className="config-group">
                  <label data-en="Size" data-ar="الحجم">Size</label>
                  <div className="size-grid">
                    <div className="size-option active" data-size="A3" data-dims="297x420">A3<br /><span>297x420</span></div>
                    <div className="size-option" data-size="A4" data-dims="210x297">A4<br /><span>210x297</span></div>
                    <div className="size-option" data-size="Other" data-dims="Custom"><span data-en="Custom" data-ar="مخصص">Custom</span><br /><span data-en="L × W" data-ar="الطول × العرض">L × W</span></div>
                  </div>
                  <CustomSizeField />
                </div>
                {/* Paper Type & Weight */}
                <div className="config-group">
                  <label htmlFor="paperType" data-en="Paper Type & Weight" data-ar="نوع الورق والوزن">Paper Type &amp; Weight</label>
                  <div className="paper-select-wrapper">
                    <img src={asset('assets/paper.svg')} alt="" className="paper-icon" />
                    <select id="paperType">
                      <option value="couche-350" data-en="Couche 350 gsm" data-ar="كوشيه 350 جم">Couche 350 gsm</option>
                      <option value="couche-300" data-en="Couche 300 gsm" data-ar="كوشيه 300 جم">Couche 300 gsm</option>
                      <option value="couche-250" data-en="Couche 250 gsm" data-ar="كوشيه 250 جم">Couche 250 gsm</option>
                      <option value="couche-200" data-en="Couche 200 gsm" data-ar="كوشيه 200 جم">Couche 200 gsm</option>
                      <option value="couche-170" data-en="Couche 170 gsm" data-ar="كوشيه 170 جم">Couche 170 gsm</option>
                      <option value="couche-150" data-en="Couche 150 gsm" data-ar="كوشيه 150 جم">Couche 150 gsm</option>
                      <option value="sticker" data-en="Sticker Paper" data-ar="ورق ملصقات">Sticker Paper</option>
                      <option value="other" data-en="Other" data-ar="آخر">Other</option>
                    </select>
                  </div>
                </div>
                {/* Printed Colors */}
                <div className="config-group">
                  <label data-en="Printed Colors" data-ar="الألوان المطبوعة">Printed Colors</label>
                  <div className="color-options">
                    <div className="color-option active" data-color="colored">
                      <img src={asset('assets/palette.svg')} alt="" className="color-icon" />
                      <div className="color-dots">
                        <span className="dot red" />
                        <span className="dot green" />
                        <span className="dot blue" />
                      </div>
                      <span data-en="Full Color" data-ar="ألوان كاملة">Full Color</span>
                    </div>
                    <div className="color-option" data-color="bw">
                      <div className="color-dots">
                        <span className="dot black" />
                        <span className="dot white" />
                      </div>
                      <span data-en="Black & White" data-ar="أبيض وأسود">Black &amp; White</span>
                    </div>
                  </div>
                </div>
                {/* Printed Sides */}
                <div className="config-group">
                  <label data-en="Printed Sides" data-ar="الجوانب المطبوعة">Printed Sides</label>
                  <div className="side-options">
                    <div className="side-option active" data-sides="single" data-en="Single Side" data-ar="جانب واحد">
                      <img src={asset('assets/paperside.svg')} alt="" />
                      <span>Single Side</span>
                    </div>
                  </div>
                </div>
                {/* Lamination */}
                <div className="config-group">
                  <label data-en="Lamination" data-ar="التغليف">Lamination</label>
                  <div className="lamination-options">
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="none" defaultChecked />
                      <span data-en="None" data-ar="لا شيء">None</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="matt-single" />
                      <img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" />
                      <span data-en="Matt Cellophane [Single Side]" data-ar="سيلوفان غير لامع [جانب واحد]">Matt Cellophane [Single Side]</span>
                    </label>
                    <label className="radio-option">
                      <input type="radio" name="lamination" defaultValue="gloss-single" />
                      <img src={asset('assets/lamination.svg')} alt="" className="lamination-icon" />
                      <span data-en="Gloss Cellophane [Single Side]" data-ar="سيلوفان لامع [جانب واحد]">Gloss Cellophane [Single Side]</span>
                    </label>
                  </div>
                </div>
                {/* Packaging */}
                <div className="config-group">
                  <label htmlFor="packaging" data-en="Packaging" data-ar="التعبئة والتغليف">Packaging</label>
                  <textarea id="packaging" placeholder="Describe your packaging requirements" rows={3} data-placeholder-en="Describe your packaging requirements" data-placeholder-ar="اوصف متطلبات التعبئة والتغليف" defaultValue={""} />
                </div>
                {/* Upload Artwork */}
                <div className="config-group">
                  <label data-en="Upload Artwork" data-ar="رفع التصميم">Upload Artwork</label>
                  <div className="upload-area" id="uploadArea">
                    <div className="upload-content">
                      <div className="upload-icon"><img src={asset('assets/upload.svg')} alt="" /></div>
                      <p data-en="Drop your files here or browse" data-ar="قم بإسقاط ملفاتك هنا أو تصفح">Drop your files here or browse</p>
                      <p className="upload-hint" data-en="Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)" data-ar="يدعم: PDF, AI, EPS, PNG, JPG, PSD (الحد الأقصى 100 ميجابايت لكل ملف)">Supports: PDF, AI, EPS, PNG, JPG, PSD (Max 100MB each)</p>
                    </div>
                    <input type="file" id="fileInput" multiple accept=".pdf,.ai,.eps,.png,.jpg,.jpeg,.psd" style={{display: 'none'}} />
                  </div>
                </div>
                {/* Additional Notes */}
                <NotesField />
              </div>
              {/* Request Summary Sidebar */}
              <div className="request-summary">
                <h3 data-en="Request Summary" data-ar="ملخص الطلب">Request Summary</h3>
                <div className="summary-details">
                  <div className="summary-item">
                    <span className="summary-label" data-en="Size:" data-ar="الحجم:">Size:</span>
                    <span className="summary-value" id="summarySize">A3</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Paper:" data-ar="الورق:">Paper:</span>
                    <span className="summary-value" id="summaryPaper">Couche 350 gsm</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Color:" data-ar="اللون:">Color:</span>
                    <span className="summary-value" id="summaryColor">Full Color</span>
                  </div>
                  <div className="summary-item">
                    <span className="summary-label" data-en="Lamination:" data-ar="التغليف:">Lamination:</span>
                    <span className="summary-value" id="summaryLamination">None</span>
                  </div>
                </div>
                <div className="delivery-estimate">
                  <strong data-en="Estimated Delivery" data-ar="التسليم المتوقع">Estimated Delivery</strong>
                  <div className="delivery-time" data-en="1-3 business days" data-ar="1-3 أيام عمل">1-3 business days</div>
                </div>
                <QuoteActions productType={title.replace(' - INGAZ Print', '')} />
                <button className="btn3"><img src={asset('assets/phone.svg')} alt="" /> <span data-en="Contact Support" data-ar="اتصل بالدعم">Contact Support</span></button>
                <div className="guarantees">
                  <div className="guarantee-item" data-en="✓ Free design review" data-ar="✓ مراجعة تصميم مجانية">✓ Free design review</div>
                  <div className="guarantee-item" data-en="✓ Quality guarantee" data-ar="✓ ضمان الجودة">✓ Quality guarantee</div>
                  <div className="guarantee-item" data-en="✓ Fast turnaround" data-ar="✓ تسليم سريع">✓ Fast turnaround</div>
                </div>
              </div>
            </div>
          </section>
          {/* Why Choose INGAZ Section */}
          <section className="why-choose-section">
            <div className="why-choose-container">
              <h2 data-en="Why Choose INGAZ?" data-ar="لماذا تختار INGAZ؟">Why Choose INGAZ?</h2>
              <p className="why-choose-subtitle" data-en="Your trusted partner for professional printing solutions" data-ar="شريكك الموثوق لحلول الطباعة الاحترافية">Your trusted partner for professional printing solutions</p>
              <div className="why-choose-grid">
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/quality.svg')} alt="" /></div>
                  <h3 data-en="High Quality" data-ar="جودة عالية">High Quality</h3>
                  <p data-en="Premium materials and cutting-edge printing technology" data-ar="مواد عالية الجودة وتقنيات طباعة متطورة">Premium materials and cutting-edge printing technology
                  </p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/power.svg')} alt="" /></div>
                  <h3 data-en="Innovative Solutions" data-ar="حلول مبتكرة">Innovative Solutions</h3>
                  <p data-en="Modern printing techniques for exceptional results" data-ar="تقنيات طباعة حديثة لنتائج استثنائية">Modern printing techniques for exceptional results</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/time.svg')} alt="" /></div>
                  <h3 data-en="Fast Turnaround" data-ar="تسليم سريع">Fast Turnaround</h3>
                  <p data-en="Express delivery options available for urgent orders" data-ar="خيارات تسليم سريع متاحة للطلبات العاجلة">Express delivery options available for urgent orders</p>
                </div>
                <div className="why-choose-card">
                  <div className="why-icon"><img src={asset('assets/dollar.svg')} alt="" /></div>
                  <h3 data-en="Value for Money" data-ar="قيمة مقابل المال">Value for Money</h3>
                  <p data-en="Competitive pricing without compromising on quality" data-ar="أسعار تنافسية دون المساس بالجودة">Competitive pricing without compromising on quality</p>
                </div>
              </div>
            </div>
          </section>
          {/* Footer */}
          <SiteFooter />
        </main>
    </>
  );
}

export default PostersProduct;
